import Select from "react-select";
import React from "react";

const OptionsOutsideSelect = (props) => {
    const { selected, disabled, isMulti } = props;

    return (
        <div className="options-outside-select">
            {isMulti && <div> {selected} </div>}
            <Select
                {...props}
                closeMenuOnScroll={props.closeOnMenuScroll}
                placeholder="-- Select --"
                menuPortalTarget={document.body}
                className="react-select-container"
                classNamePrefix="react-select"
                isDisabled={disabled}
                styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                }}
            />
        </div>
    );
};

export default OptionsOutsideSelect;
